import { RouterOutputs, trpc } from "../trpc";

interface Input {
  ids: number[];
}

export type Team = RouterOutputs["member"]["teams"][string];
export type Teams = Record<string, Team>;

export function useTeams({ ids }: Input) {
  const teams = trpc.member.teams.useQuery(
    { ids: ids.map(String) },
    { enabled: ids.length > 0 },
  );

  return {
    teams: teams.data || ({} as Teams),
    isLoading: teams.isLoading,
    isPending: teams.isPending,
  };
}
